export { default } from "../../../components/LocationManagementPage/LocationManagementPage";
